// src/features/asset/AssetDetail.js
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAssetById, resetFetchByIdStatus, deleteAssetById, resetDeleteStatus } from './assetSlice';
import { useParams, useNavigate } from 'react-router-dom';

const AssetDetail = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const { singleAsset, fetchByIdStatus, deleteStatus, error } = useSelector((state) => state.asset);

    useEffect(() => {
        dispatch(fetchAssetById(id));

        return () => {
            dispatch(resetFetchByIdStatus()); // Clean up status when component unmounts
            dispatch(resetDeleteStatus());
        };
    }, [dispatch, id]);

    useEffect(() => {
      if (deleteStatus === 'succeeded') {
          navigate('/assets'); // Redirect to asset list after deletion
      }
    }, [deleteStatus, navigate]);

    const handleDelete = () => {
      dispatch(deleteAssetById(id));
    };

    if (fetchByIdStatus === 'loading') {
        return <p>Loading asset...</p>;
    }

    if (fetchByIdStatus === 'failed') {
        return <p style={{ color: 'red' }}>{error || 'Failed to load asset'}</p>;
    }

    if (!singleAsset) {
        return <p>No asset found.</p>;
    }

    return (
        <div>
            <h2>Asset Details</h2>
            <p><strong>Symbol:</strong> {singleAsset.symbol}</p>
            <p><strong>Name:</strong> {singleAsset.name}</p>
            <p><strong>Type:</strong> {singleAsset.assetType}</p>
            
            {/* Delete Button */}
            <button onClick={handleDelete} disabled={deleteStatus === 'loading'}>
                {deleteStatus === 'loading' ? 'Deleting...' : 'Delete Asset'}
            </button>
            {error && <p style={{ color: 'red' }}>{error}</p>}
        </div>
    );
};

export default AssetDetail;